<div class="tpl3pl-page-container tpl3pl-shipments">

	<!-- ── Stat bar ─────────────────────────────────────────────────────── -->
	<div class="sh-stats-wrap">
		<div class="sh-stats-loading" *ngIf="statsLoading && !stats">
			<mat-spinner diameter="24"></mat-spinner>
			<span>Loading…</span>
		</div>
		<div class="sh-stats" *ngIf="stats as s">
			<div class="sh-stat sh-stat--accent sh-stat--interactive"
				(click)="!statsLoading && filterActionableStatuses()"
				(keydown.enter)="!statsLoading && filterActionableStatuses()"
				(keydown.space)="$event.preventDefault(); !statsLoading && filterActionableStatuses()"
				tabindex="0"
				role="button"
				[attr.aria-label]="'Filter list: actionable shipments'"
				[attr.aria-disabled]="statsLoading ? 'true' : null">
				<span class="sh-stat-val">{{ s.actionable }}</span>
				<span class="sh-stat-lbl">Actionable</span>
			</div>
			<div class="sh-stat sh-stat--warn sh-stat--interactive"
				(click)="!statsLoading && filterMissingDebtortrans10()"
				(keydown.enter)="!statsLoading && filterMissingDebtortrans10()"
				(keydown.space)="$event.preventDefault(); !statsLoading && filterMissingDebtortrans10()"
				tabindex="0"
				role="button"
				[attr.aria-label]="'Filter list: shipped with no invoice'"
				[attr.aria-disabled]="statsLoading ? 'true' : null">
				<span class="sh-stat-val">{{ s.missing_debtortrans_10 != null ? s.missing_debtortrans_10 : '—' }}</span>
				<span class="sh-stat-lbl">No invoice</span>
			</div>
			<div class="sh-stat sh-stat--interactive"
				(click)="!statsLoading && filterByInvoiceStatuses(['pending'])"
				(keydown.enter)="!statsLoading && filterByInvoiceStatuses(['pending'])"
				(keydown.space)="$event.preventDefault(); !statsLoading && filterByInvoiceStatuses(['pending'])"
				tabindex="0"
				role="button"
				[attr.aria-label]="'Filter list: pending invoice status'"
				[attr.aria-disabled]="statsLoading ? 'true' : null">
				<span class="sh-stat-val">{{ s.pending }}</span>
				<span class="sh-stat-lbl">Pending</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.approved }}</span>
				<span class="sh-stat-lbl">Approved</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.invoicing }}</span>
				<span class="sh-stat-lbl">Invoicing</span>
			</div>
			<div class="sh-stat sh-stat--ok">
				<span class="sh-stat-val">{{ s.invoiced }}</span>
				<span class="sh-stat-lbl">Invoiced</span>
			</div>
			<div class="sh-stat sh-stat--warn sh-stat--interactive"
				(click)="!statsLoading && filterByInvoiceStatuses(['failed'])"
				(keydown.enter)="!statsLoading && filterByInvoiceStatuses(['failed'])"
				(keydown.space)="$event.preventDefault(); !statsLoading && filterByInvoiceStatuses(['failed'])"
				tabindex="0"
				role="button"
				[attr.aria-label]="'Filter list: failed invoice status'"
				[attr.aria-disabled]="statsLoading ? 'true' : null">
				<span class="sh-stat-val">{{ s.failed }}</span>
				<span class="sh-stat-lbl">Failed</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.on_hold }}</span>
				<span class="sh-stat-lbl">On hold</span>
			</div>
			<div class="sh-stat">
				<span class="sh-stat-val">{{ s.rejected }}</span>
				<span class="sh-stat-lbl">Rejected</span>
			</div>
		</div>
	</div>

	<!-- ── Filter bar ───────────────────────────────────────────────────── -->
	<div class="sh-filter-bar">
		<mat-form-field appearance="outline" class="sh-field sh-field--order">
			<mat-label>Order number</mat-label>
			<input matInput [(ngModel)]="ordernoFilter" (keyup.enter)="applyFilters()" placeholder="Exact order #">
		</mat-form-field>
		<mat-form-field appearance="outline" class="sh-field sh-field--status">
			<mat-label>Invoice status</mat-label>
			<mat-select multiple [(ngModel)]="invoiceStatusFilters">
				<mat-option *ngFor="let o of invoiceStatusOptions" [value]="o.value">{{ o.label }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="sh-field sh-field--status">
			<mat-label>ERP order status</mat-label>
			<mat-select multiple [(ngModel)]="erpStatusFilters">
				<mat-option *ngFor="let s of orderStatusesForSelect" [value]="+s.order_status_id">{{ s.name }} ({{ s.order_status_id }})</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Ship from</mat-label>
			<input matInput [matDatepicker]="filterFromPicker" [(ngModel)]="filterDateStart" [max]="filterDateEnd">
			<mat-datepicker-toggle matSuffix [for]="filterFromPicker"></mat-datepicker-toggle>
			<mat-datepicker #filterFromPicker></mat-datepicker>
		</mat-form-field>
		<span class="sh-date-sep">–</span>
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Ship to</mat-label>
			<input matInput [matDatepicker]="filterToPicker" [(ngModel)]="filterDateEnd" [min]="filterDateStart">
			<mat-datepicker-toggle matSuffix [for]="filterToPicker"></mat-datepicker-toggle>
			<mat-datepicker #filterToPicker></mat-datepicker>
		</mat-form-field>
		<mat-checkbox [(ngModel)]="missingDebtortrans10Filter" (change)="applyFilters()" class="sh-field sh-field--chk">
			Shipped, no invoice
		</mat-checkbox>
		<button mat-flat-button color="primary" (click)="applyFilters()" [disabled]="loading">
			<mat-icon>filter_list</mat-icon> Apply
		</button>
		<button mat-stroked-button (click)="clearFilters()" [disabled]="loading">
			<mat-icon>clear_all</mat-icon> Clear
		</button>
		<div class="sh-filter-spacer"></div>
		<button mat-stroked-button type="button" (click)="clearSort()" *ngIf="sortColumn" [disabled]="loading">
			<mat-icon>clear</mat-icon> Clear sort
		</button>
		<button mat-stroked-button [matMenuTriggerFor]="shipmentsExportMenu" [disabled]="loading || exportingReport || shipmentsTotal === 0">
			<mat-spinner *ngIf="exportingReport" diameter="18" class="sh-export-spinner"></mat-spinner>
			<mat-icon *ngIf="!exportingReport">file_download</mat-icon>
			Export
		</button>
		<mat-menu #shipmentsExportMenu="matMenu">
			<button mat-menu-item (click)="buildShipmentsHtmlAndExport('pdf', 'page')" [disabled]="exportingReport || shipments.length === 0">
				<mat-icon>picture_as_pdf</mat-icon>
				<span>PDF — this page</span>
			</button>
			<button mat-menu-item (click)="buildShipmentsHtmlAndExport('xlsx', 'page')" [disabled]="exportingReport || shipments.length === 0">
				<mat-icon>table_view</mat-icon>
				<span>Excel — this page</span>
			</button>
			<mat-divider></mat-divider>
			<button mat-menu-item (click)="buildShipmentsHtmlAndExport('pdf', 'all')" [disabled]="exportingReport">
				<mat-icon>picture_as_pdf</mat-icon>
				<span>PDF — all matching (max {{ shipmentsExportMaxRows }})</span>
			</button>
			<button mat-menu-item (click)="buildShipmentsHtmlAndExport('xlsx', 'all')" [disabled]="exportingReport">
				<mat-icon>table_view</mat-icon>
				<span>Excel — all matching (max {{ shipmentsExportMaxRows }})</span>
			</button>
		</mat-menu>
		<button mat-stroked-button (click)="loadShipments()" [disabled]="loading">
			<mat-icon>refresh</mat-icon> Refresh
		</button>
		<button mat-stroked-button (click)="openRawRequestResponse()" [disabled]="rawLoading">
			<mat-spinner *ngIf="rawLoading" diameter="16"></mat-spinner>
			<mat-icon *ngIf="!rawLoading">visibility</mat-icon> View raw
		</button>
	</div>

	<!-- ── Quick date filters ────────────────────────────────────────────── -->
	<div class="sh-quick-filters">
		<span class="sh-quick-label">Ship date:</span>
		<button mat-button (click)="setQuickDateFilter(7)" [disabled]="loading">Last 7 days</button>
		<button mat-button (click)="setQuickDateFilter(14)" [disabled]="loading">Last 14 days</button>
		<button mat-button (click)="setQuickDateFilter(30)" [disabled]="loading">Last 30 days</button>
		<button mat-button (click)="setQuickDateFilter(90)" [disabled]="loading">Last 90 days</button>
		<span class="sh-quick-sep" aria-hidden="true"></span>
		<span class="sh-quick-label">Invoice status:</span>
		<button mat-button color="primary" [class.sh-quick-active]="invoiceQuickFilterEquals(['pending'])"
			(click)="filterByInvoiceStatuses(['pending'])" [disabled]="loading">Pending</button>
		<button mat-button color="primary" [class.sh-quick-active]="invoiceQuickFilterEquals(['failed'])"
			(click)="filterByInvoiceStatuses(['failed'])" [disabled]="loading">Failed</button>
		<button mat-button color="primary" [class.sh-quick-active]="invoiceQuickFilterEquals(['pending','failed'])"
			(click)="filterByInvoiceStatuses(['pending','failed'])" [disabled]="loading">Pending + failed</button>
		<button mat-button (click)="filterActionableStatuses()" [disabled]="loading"
			[class.sh-quick-active]="invoiceQuickFilterEquals(['pending','approved','failed'])">Actionable</button>
	</div>

	<!-- ── Poll bar ─────────────────────────────────────────────────────── -->
	<div class="sh-poll-bar">
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Poll from</mat-label>
			<input matInput [matDatepicker]="pollFromPicker" [(ngModel)]="pollDateStart" [max]="pollDateEnd">
			<mat-datepicker-toggle matSuffix [for]="pollFromPicker"></mat-datepicker-toggle>
			<mat-datepicker #pollFromPicker></mat-datepicker>
		</mat-form-field>
		<span class="sh-date-sep">–</span>
		<mat-form-field appearance="outline" class="sh-field sh-field--date">
			<mat-label>Poll to</mat-label>
			<input matInput [matDatepicker]="pollToPicker" [(ngModel)]="pollDateEnd" [min]="pollDateStart">
			<mat-datepicker-toggle matSuffix [for]="pollToPicker"></mat-datepicker-toggle>
			<mat-datepicker #pollToPicker></mat-datepicker>
		</mat-form-field>
		<button mat-flat-button color="accent" (click)="pollShipments()" [disabled]="loading">
			<mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
			<mat-icon *ngIf="!loading">sync</mat-icon> Poll Shipments
		</button>
		<span *ngIf="autoInvoiceEnabled" class="sh-auto-invoice-warn"
			matTooltip="Auto-invoice on shipment is ON — polling will automatically invoice newly imported shipments. You will be asked to confirm before polling.">
			<mat-icon>warning</mat-icon> Auto-invoice ON
		</span>
		<ng-container *ngIf="showCheckOrderByNo">
			<div class="sh-poll-sep"></div>
			<mat-form-field appearance="outline" class="sh-field sh-field--order">
				<mat-label>Order number</mat-label>
				<input matInput [(ngModel)]="singleOrderToCheck" (keyup.enter)="checkSingleOrder()" placeholder="Poll PGS for one order">
			</mat-form-field>
			<mat-form-field appearance="outline" class="sh-field sh-field--channel">
				<mat-label>Channel</mat-label>
				<mat-select [(ngModel)]="checkOrderChannel">
					<mat-option value="both">Both</mat-option>
					<mat-option value="b2b">B2B only</mat-option>
					<mat-option value="b2c">B2C only</mat-option>
				</mat-select>
			</mat-form-field>
			<button mat-flat-button color="primary" (click)="checkSingleOrder()" [disabled]="checkOrderLoading || !singleOrderToCheck?.trim()">
				<mat-spinner *ngIf="checkOrderLoading" diameter="16"></mat-spinner>
				<mat-icon *ngIf="!checkOrderLoading">search</mat-icon> Fetch from PGS
			</button>
		</ng-container>
	</div>

	<div class="sh-poll-status" *ngIf="pollStatusMessage">
		<mat-spinner diameter="18"></mat-spinner>
		<span>{{ pollStatusMessage }}</span>
	</div>

	<!-- ── Bulk actions ──────────────────────────────────────────────────── -->
	<div class="sh-bulk-bar" *ngIf="selectedCount > 0 || bulkActionInProgress">
		<span class="sh-bulk-count" *ngIf="!bulkActionInProgress">{{ selectedCount }} selected</span>
		<div class="sh-bulk-progress" *ngIf="bulkActionInProgress">
			<mat-spinner diameter="22"></mat-spinner>
			<span class="sh-bulk-progress-text">{{ bulkActionStatusText }}</span>
		</div>
		<button mat-flat-button color="primary" (click)="bulkApprove()" [disabled]="!canBulkApprove">
			<mat-spinner *ngIf="bulkActionMode === 'approve'" diameter="18" class="sh-btn-spinner"></mat-spinner>
			<mat-icon *ngIf="bulkActionMode !== 'approve'">check</mat-icon>
			Bulk approve
		</button>
		<button mat-stroked-button color="accent" (click)="bulkApproveAndInvoice()" [disabled]="!canBulkApprove">
			<mat-spinner *ngIf="bulkActionMode === 'invoice'" diameter="18" class="sh-btn-spinner"></mat-spinner>
			<mat-icon *ngIf="bulkActionMode !== 'invoice'">receipt_long</mat-icon>
			Bulk approve &amp; invoice
		</button>
		<button mat-stroked-button color="primary" (click)="bulkReauthSelected()" [disabled]="!canBulkReauthCards">
			<mat-spinner *ngIf="bulkActionMode === 'reauth'" diameter="18" class="sh-btn-spinner"></mat-spinner>
			<mat-icon *ngIf="bulkActionMode !== 'reauth'">sync_problem</mat-icon>
			Re-auth card ({{ bulkReauthSelectedCount }})
		</button>
	</div>

	<!-- ── Table ─────────────────────────────────────────────────────────── -->
	<div class="sh-table-wrap position-relative">
		<div *ngIf="tableBusy" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p *ngIf="bulkActionInProgress && bulkActionStatusText" class="sh-bulk-overlay-msg">{{ bulkActionStatusText }}</p>
		</div>
		<table class="sh-table" [class.tpl3pl-loading-opacity]="tableBusy">
			<thead>
				<tr>
					<th class="sh-col-check">
						<mat-checkbox
							[checked]="isAllPendingSelected()"
							[indeterminate]="isBulkSelectionIndeterminate()"
							[disabled]="bulkEligibleOnPage.length === 0"
							(change)="toggleSelectAllPending($event.checked)"
							matTooltip="Select every actionable row on this page (pending, approved, or failed). Invoiced / on hold / rejected rows are skipped.">
						</mat-checkbox>
					</th>
					<th class="sh-col-order sh-th-sort" (click)="setSortColumn('orderno', $event)">Order {{ sortIndicator('orderno') }}</th>
					<th class="sh-col-debtor sh-th-sort" (click)="setSortColumn('debtorno', $event)">Debtor # {{ sortIndicator('debtorno') }}</th>
					<th class="sh-col-name sh-th-sort" (click)="setSortColumn('customer_name', $event)">Name {{ sortIndicator('customer_name') }}</th>
					<th class="sh-col-terms sh-th-sort" (click)="setSortColumn('payterms', $event)">Terms {{ sortIndicator('payterms') }}</th>
					<th class="sh-col-tracking sh-th-sort" (click)="setSortColumn('tracking', $event)">Tracking {{ sortIndicator('tracking') }}</th>
					<th class="sh-col-carrier sh-th-sort" (click)="setSortColumn('carrier', $event)">Carrier {{ sortIndicator('carrier') }}</th>
					<th class="sh-col-date sh-th-sort" (click)="setSortColumn('ship_date', $event)">Ship Date {{ sortIndicator('ship_date') }}</th>
					<th class="sh-col-status sh-th-sort" (click)="setSortColumn('invoice_status', $event)">Invoice Status {{ sortIndicator('invoice_status') }}</th>
					<th class="sh-col-phase sh-th-sort" (click)="setSortColumn('phase', $event)">Phase {{ sortIndicator('phase') }}</th>
					<th class="sh-col-money sh-th-sort" (click)="setSortColumn('invoice_total', $event)">Invoice $ {{ sortIndicator('invoice_total') }}</th>
					<th class="sh-col-money sh-th-sort" (click)="setSortColumn('last_auth_amount', $event)">Last Auth {{ sortIndicator('last_auth_amount') }}</th>
					<th class="sh-col-erp-gap" matTooltip="Captured (C) auth exists but neither capture nor cc_transactions has this transaction id. Either record is enough to clear the gap. Record ERP Capture backfills — does NOT call Stripe.">ERP Gap</th>
					<th class="sh-col-attempts sh-th-sort" (click)="setSortColumn('attempts', $event)">Att. {{ sortIndicator('attempts') }}</th>
					<th class="sh-col-error">Error</th>
					<th class="sh-col-actions">Actions</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let item of shipments; let ri = index; trackBy: trackShipmentById">
					<tr class="sh-data-row"
						[class.sh-row-alt]="ri % 2 === 1"
						[class.sh-row-failed]="resolveInvoiceStatus(item) === 'failed'"
						[class.sh-row-invoiced]="resolveInvoiceStatus(item) === 'invoiced'"
						[class.sh-row-hold]="resolveInvoiceStatus(item) === 'on_hold'"
						[class.sh-row-rejected]="resolveInvoiceStatus(item) === 'rejected'">
						<td class="sh-col-check">
							<mat-checkbox *ngIf="canSelectShipment(item)"
								[checked]="isSelected(item)"
								(change)="toggleSelect(item, $event.checked)"
								matTooltip="Include in bulk approve / bulk invoice">
							</mat-checkbox>
							<span *ngIf="!canSelectShipment(item)" class="sh-check-na" matTooltip="Not eligible for bulk actions">—</span>
						</td>
						<td class="sh-col-order">
							<a href="javascript:void(0)" (click)="viewOrder(item.orderno)" class="sh-order-link">{{ item.orderno }}</a>
						</td>
						<td class="sh-col-debtor" [matTooltip]="item.debtorno ? ('Open customer ' + item.debtorno) : ''">
							<a *ngIf="item.debtorno" [routerLink]="'/customers/view/' + item.debtorno" class="sh-debtor-link">{{ item.debtorno }}</a>
							<span *ngIf="!item.debtorno">—</span>
						</td>
						<td class="sh-col-name" [matTooltip]="item.customer_name || ''">{{ item.customer_name || '—' }}</td>
						<td class="sh-col-terms" [matTooltip]="item.payterms || ''">{{ item.payterms || '—' }}</td>
						<td class="sh-col-tracking" [matTooltip]="item.tracking_number || ''">
							<ng-container *ngIf="item.tracking_number && (item.tracking_number | trackingUrl:item.carrier) as shHref; else shTrkPlain">
								<a class="tracking-link d-inline-flex align-items-center" [href]="shHref" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
									{{ item.tracking_number }}
									<mat-icon class="ml-1" style="font-size:16px;width:16px;height:16px;">open_in_new</mat-icon>
								</a>
							</ng-container>
							<ng-template #shTrkPlain><span>{{ item.tracking_number || '—' }}</span></ng-template>
						</td>
						<td class="sh-col-carrier" [matTooltip]="item.carrier || ''">{{ item.carrier || '—' }}</td>
						<td class="sh-col-date">{{ item.ship_date | date:'shortDate' }}</td>
						<td class="sh-col-status">
							<span class="sh-badge" [ngClass]="invoiceStatusClass(resolveInvoiceStatus(item))">
								{{ invoiceStatusLabel(resolveInvoiceStatus(item)) }}
							</span>
						</td>
						<td class="sh-col-phase">
							<span class="sh-badge sh-phase-badge"
								[ngClass]="{
									'phase-pre-invoice': processedPhaseNorm(item) === 'pre_invoice',
									'phase-pending-review': processedPhaseNorm(item) === 'pending_review',
									'phase-auto-invoiced': processedPhaseNorm(item) === 'auto_invoiced',
									'phase-invoice-failed': processedPhaseNorm(item) === 'invoice_failed'
								}"
								[matTooltip]="item.invoice_message || phaseLabelFromItem(item)">
								{{ phaseLabelFromItem(item) }}
							</span>
						</td>
						<td class="sh-col-money sh-money">
							<ng-container *ngIf="item.invoice_total != null">
								<span [matTooltip]="item.invoice_transno ? 'Invoice #' + item.invoice_transno : ''">
									{{ item.invoice_total | currency:'USD':'symbol':'1.2-2' }}
								</span>
							</ng-container>
							<span *ngIf="item.invoice_total == null" class="text-muted">—</span>
						</td>
						<td class="sh-col-money sh-money sh-auth-cell">
							<ng-container *ngIf="item.last_auth_amount != null && item.last_auth_amount > 0">
								<div class="sh-auth-line"
									[class.sh-auth-mismatch]="item.invoice_total != null && item.last_auth_amount != null && (item.invoice_total - item.last_auth_amount) > 0.01"
									[matTooltip]="item.last_auth_transid || ''">
									<span class="sh-auth-amt">{{ item.last_auth_amount | currency:'USD':'symbol':'1.2-2' }}</span>
									<span class="sh-auth-stat">{{ lastAuthStatusLabel(item.last_auth_status) }}</span>
								</div>
							</ng-container>
							<span *ngIf="item.last_auth_amount == null || item.last_auth_amount === 0" class="text-muted">—</span>
						</td>
						<td class="sh-col-erp-gap">
							<ng-container *ngIf="item.reconcile_auth_id">
								<span class="sh-erp-gap-badge"
									matTooltip="Captured auth with no capture or cc_transactions row (either clears gap). Use Record ERP Capture in Actions (⋮). Does NOT call Stripe.">
									ERP Gap
								</span>
							</ng-container>
							<span *ngIf="!item.reconcile_auth_id" class="text-muted">—</span>
						</td>
						<td class="sh-col-attempts">{{ item.invoice_attempts || 0 }}</td>
						<td class="sh-col-error" [matTooltip]="item.invoice_message || ''">
							<span *ngIf="item.invoice_message" class="sh-error-text">{{ item.invoice_message }}</span>
							<span *ngIf="!item.invoice_message" class="text-muted">—</span>
						</td>
						<td class="sh-col-actions">
							<div class="sh-actions">
								<mat-spinner *ngIf="actionInProgressId === item.id" diameter="20"></mat-spinner>
								<ng-container *ngIf="actionInProgressId !== item.id">
									<button mat-icon-button color="accent" (click)="openInvoicePreview(item)" matTooltip="Invoice preview"><mat-icon>preview</mat-icon></button>
									<button
										mat-icon-button
										color="primary"
										*ngIf="canReauthShipmentCard(item)"
										(click)="reauthShipmentCard(item); $event.stopPropagation()"
										[disabled]="bulkActionInProgress"
										matTooltip="Re-authorize card for this shipment’s invoice total (before Approve &amp; invoice). Same as ⋮ Re-authorize card.">
										<mat-icon>sync_problem</mat-icon>
									</button>
									<button mat-icon-button
										class="sh-actions-overflow"
										[matMenuTriggerFor]="shipmentActionsMenu"
										(click)="actionMenuShipment = item"
										[disabled]="bulkActionInProgress"
										matTooltip="All actions (mark invoiced, capture, approve, …)">
										<mat-icon>more_vert</mat-icon>
									</button>
									<button mat-icon-button (click)="toggleExpand(item)" [matTooltip]="expandedShipmentId === item.id ? 'Collapse raw JSON' : 'View raw JSON'">
										<mat-icon>{{ expandedShipmentId === item.id ? 'expand_less' : 'data_object' }}</mat-icon>
									</button>
								</ng-container>
							</div>
						</td>
					</tr>
					<tr *ngIf="expandedShipmentId === item.id" class="sh-raw-row">
						<td colspan="16">
							<pre class="sh-raw-pre">{{ item.raw_data | json }}</pre>
						</td>
					</tr>
				</ng-container>
				<tr *ngIf="!loading && shipments.length === 0">
					<td colspan="16" class="sh-empty">No shipments found for the current filters.</td>
				</tr>
			</tbody>
		</table>

		<mat-paginator
			*ngIf="shipmentsTotal > 0"
			[length]="shipmentsTotal"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[pageSizeOptions]="pageSizeOptions"
			(page)="onPage($event)"
			showFirstLastButtons>
		</mat-paginator>
	</div>

	<!-- ── Poll result ───────────────────────────────────────────────────── -->
	<div *ngIf="lastPollResult" class="sh-poll-result mt-3"
		[ngClass]="{
			'sh-poll-ok': lastPollResult.success && lastPollResult.processed > 0,
			'sh-poll-none': lastPollResult.success && lastPollResult.processed === 0,
			'sh-poll-err': !lastPollResult.success
		}">
		<div class="sh-poll-result-body">
			<strong>{{ !lastPollResult.success ? 'Poll failed:' : (lastPollResult.processed > 0 ? 'Poll complete:' : 'No shipments:') }}</strong>
			{{ lastPollResult.message }}
			<span *ngIf="lastPollResult.success && lastPollResult.processed !== undefined"> ({{ lastPollResult.processed }} processed)</span>
		</div>
		<button type="button" class="sh-poll-close" (click)="lastPollResult = null" aria-label="Close">×</button>
	</div>
	<div *ngIf="!lastPollResult?.success && lastPollResult?.response" class="mt-2">
		<details>
			<summary class="sh-details-summary">API response</summary>
			<pre class="sh-raw-pre mt-1">{{ lastPollResult.response | json }}</pre>
		</details>
	</div>

<mat-menu #shipmentActionsMenu="matMenu" class="sh-actions-menu">
	<button mat-menu-item (click)="runMenuPreview()">
		<mat-icon>preview</mat-icon>
		<span>Invoice preview</span>
	</button>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="runMenuMarkInvoiced()" [disabled]="!menuCanMarkInvoiced()">
		<mat-icon class="sh-menu-ic-mark-invoiced">check_circle</mat-icon>
		<span>Mark row invoiced (sync queue)</span>
	</button>
	<button mat-menu-item (click)="runMenuMarkCaptured()" [disabled]="!menuCanMarkCaptured()">
		<mat-icon class="sh-menu-ic-capture">check_circle</mat-icon>
		<span>Record ERP capture / card txn</span>
	</button>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="runMenuApprove()" [disabled]="!menuCanApprove()">
		<mat-icon>check_circle</mat-icon>
		<span>Approve</span>
	</button>
	<button mat-menu-item (click)="runMenuApproveAndInvoice()" [disabled]="!menuCanApproveAndInvoice()">
		<mat-icon>receipt_long</mat-icon>
		<span>Approve &amp; invoice</span>
	</button>
	<button mat-menu-item (click)="runMenuRetryInvoice()" [disabled]="!menuCanRetryInvoice()">
		<mat-icon>refresh</mat-icon>
		<span>Retry invoice</span>
	</button>
	<button mat-menu-item (click)="runMenuResolveSkuMapping()" [disabled]="!menuCanResolveSkuMapping()">
		<mat-icon>rule</mat-icon>
		<span>Resolve SKU mapping</span>
	</button>
	<button mat-menu-item (click)="runMenuReauthCard()" [disabled]="!menuCanReauthCard()">
		<mat-icon>sync_problem</mat-icon>
		<span>Re-authorize — shipment invoice total</span>
	</button>
	<button mat-menu-item (click)="runMenuReauthOrderOpenBalance()" [disabled]="!menuCanReauthOrderOpenBalance()">
		<mat-icon>credit_card</mat-icon>
		<span>Re-authorize — full open order balance</span>
	</button>
	<button mat-menu-item (click)="runMenuAttachSavedCard()" [disabled]="!menuCanAttachSavedCard()">
		<mat-icon>credit_card</mat-icon>
		<span>Attach saved card to order</span>
	</button>
	<button mat-menu-item (click)="runMenuInvoiceOnAccount()" [disabled]="!menuCanInvoiceOnAccount()">
		<mat-icon>money_off</mat-icon>
		<span>Invoice on account (no card)</span>
	</button>
	<mat-divider></mat-divider>
	<button mat-menu-item (click)="runMenuHold()" [disabled]="!menuCanHold()">
		<mat-icon>pause_circle_outline</mat-icon>
		<span>Put on hold</span>
	</button>
	<button mat-menu-item (click)="runMenuReleaseHold()" [disabled]="!menuCanReleaseHold()">
		<mat-icon>play_circle_outline</mat-icon>
		<span>Release hold</span>
	</button>
	<button mat-menu-item (click)="runMenuReject()" [disabled]="!menuCanReject()">
		<mat-icon>cancel</mat-icon>
		<span>Reject</span>
	</button>
</mat-menu>

	<!-- ── Shipment Import Activity ── -->
	<hr class="my-4">
	<div class="d-flex align-items-center mb-2" style="gap:8px">
		<strong class="small">Shipment Import Activity</strong>
	</div>

	<div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:140px">
			<mat-label>Status</mat-label>
			<mat-select [(ngModel)]="activityFilterStatus" (selectionChange)="loadActivity()">
				<mat-option value="">All</mat-option>
				<mat-option value="success">Success</mat-option>
				<mat-option value="error">Error</mat-option>
				<mat-option value="warning">Warning</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
			<mat-label>From</mat-label>
			<input matInput type="date" [(ngModel)]="activityFilterFromDate" (change)="loadActivity()">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
			<mat-label>To</mat-label>
			<input matInput type="date" [(ngModel)]="activityFilterToDate" (change)="loadActivity()">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:180px">
			<mat-label>Order #</mat-label>
			<input matInput [(ngModel)]="activityFilterPo" (keyup.enter)="loadActivity()" placeholder="Optional">
		</mat-form-field>
		<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:110px">
			<mat-label>Limit</mat-label>
			<mat-select [(ngModel)]="activityLimit" (selectionChange)="loadActivity()">
				<mat-option [value]="50">50</mat-option>
				<mat-option [value]="100">100</mat-option>
				<mat-option [value]="250">250</mat-option>
				<mat-option [value]="500">500</mat-option>
			</mat-select>
		</mat-form-field>
		<button mat-stroked-button (click)="loadActivity()" [disabled]="activityLoading">
			<mat-spinner *ngIf="activityLoading" diameter="18"></mat-spinner>
			<mat-icon *ngIf="!activityLoading">refresh</mat-icon>
			Refresh
		</button>
		<button mat-stroked-button (click)="resetActivityFilters()" matTooltip="Reset to last 30 days, errors only">
			<mat-icon>clear</mat-icon>
			Reset
		</button>
		<span class="text-muted small ml-auto" *ngIf="activityTotal > 0">
			Showing {{ activityRows.length }} of {{ activityTotal }} total
		</span>
	</div>

	<div *ngIf="activityError" class="alert alert-warning py-2 small">{{ activityError }}</div>
	<div *ngIf="activityLoading && activityRows.length === 0" class="text-muted small">Loading…</div>
	<div *ngIf="!activityLoading && activityRows.length === 0 && !activityError" class="alert alert-success py-2 small">
		No shipment import activity matches these filters.
	</div>

	<table *ngIf="activityRows.length > 0" class="table table-sm table-hover">
		<thead>
			<tr>
				<th>When</th>
				<th>Status</th>
				<th>Order#</th>
				<th>Message</th>
				<th class="text-nowrap"></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let e of activityRows">
				<td class="text-nowrap text-muted small">{{ e.created_at | date:'M/d/yy, h:mm a' }}</td>
				<td class="text-nowrap">
					<span class="badge" [ngClass]="{
						'badge-success': e.status === 'success',
						'badge-danger': e.status === 'error',
						'badge-warning': e.status === 'warning'
					}">{{ e.status }}</span>
				</td>
				<td class="font-weight-bold small">{{ e.orderno || '—' }}</td>
				<td class="small" [ngClass]="{'text-danger': e.status === 'error'}" style="max-width:38rem;word-break:break-word;">{{ e.message }}</td>
				<td class="text-nowrap">
					<button mat-icon-button (click)="openActivityAttemptRaw(e)" matTooltip="View raw">
						<mat-icon>code</mat-icon>
					</button>
				</td>
			</tr>
		</tbody>
	</table>

</div>
